import type { Warehouse } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WarehousesService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getWarehouses = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Warehouse[]>({
      method: 'GET',
      url: '/api/app/warehouses/warehouses',
    },
    { apiName: this.apiName,...config });
}